


const Vue = require('vue')
const VueRouter = require('vue-router')
import FastClick from 'fastclick'
import App from './App'
import router from "./router";
import cookie from 'vux/src/tools/cookie/index.js'



cookie.set("token","hd");
Vue.use(VueRouter)

FastClick.attach(document.body)

Vue.config.productionTip = false
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)
import XInput from 'vux/src/components/x-input/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

Vue.component('toast', Toast)
Vue.component('x-input', XInput)
Vue.component('loading', Loading)
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
/* eslint-disable no-new */


router.beforeEach((to,from,next)=>{
if (to.path) {
_hmt.push(['_trackPageview', '/#' + to.fullPath]);
}
next();
})
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js